module.exports = __webpack_public_path__ + "static/js/0.b678c83e.chunk.worker.js"